"use client";
'use strict';

var React = require('react');
var auth = require('@sravni/utils/lib/auth');

const generateLinkProps = (data) => {
    const { isNewWindow, ...rest } = data;
    const href = auth.getLogoutUrl({ isNewWindow, ...rest });
    const rel = isNewWindow ? 'opener' : undefined;
    const target = isNewWindow ? '_blank' : undefined;
    return {
        href,
        ...(rel ? { rel } : {}),
        ...(target ? { target } : {}),
    };
};
function useAuthLogoutLink(props) {
    const [linkProps, setLinkProps] = React.useState(() => generateLinkProps({ ...props }));
    React.useEffect(() => {
        setLinkProps(generateLinkProps({ ...props }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, Object.values(props || {}));
    return linkProps;
}

exports.useAuthLogoutLink = useAuthLogoutLink;
//# sourceMappingURL=useAuthLogoutLink.js.map
